import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.17 1.92a.75.75 0 0 0-.54.12l.1-.07a.62.62 0 0 1 .44-.05Zm3.68 7.67a.21.21 0 0 1-.06.1 4.31 4.31 0 0 1-3.47 1.36A5.27 5.27 0 0 1 9 10.47a4.83 4.83 0 0 0-2.62-.56l1.87 3.95a.75.75 0 0 1-.36 1 .71.71 0 0 1-.32.07.73.73 0 0 1-.67-.43L4.59 9.7a.54.54 0 0 1 0-.11L1.41 3l-.27-.6a.76.76 0 0 1 .36-1 .74.74 0 0 1 1 .36v.09a6.32 6.32 0 0 1 3.91.63A4 4 0 0 0 8.18 3a3 3 0 0 0 2.29-.79l.08-.08h.05a.76.76 0 0 1 .78 0l.1.07a.94.94 0 0 1 .1.1.86.86 0 0 1 .1.16L14.85 9a.72.72 0 0 1 0 .59Zm-1.59-.52-2.49-5.24a5 5 0 0 1-2.59.64 5.37 5.37 0 0 1-2.34-.62 4.94 4.94 0 0 0-2.62-.57l2.45 5.19a6.31 6.31 0 0 1 3.91.64 4.08 4.08 0 0 0 1.72.48 3.45 3.45 0 0 0 1.96-.52Z';
const draw24px =
  'M22.67,14.07,17.88,3.91s0,0,0,0l-.07-.11-.1-.1s0,0,0,0a0,0,0,0,1,0,0l-.1-.06a.44.44,0,0,0-.16-.06.63.63,0,0,0-.19,0,.71.71,0,0,0-.32.07.57.57,0,0,0-.18.12l-.09.09,0,0a5,5,0,0,1-3.8,1.33A6.46,6.46,0,0,1,10,4.34a9.23,9.23,0,0,0-6.06-.9L3.72,3a.76.76,0,0,0-1-.36.75.75,0,0,0-.36,1l.42.89.06.12,4.73,10a.83.83,0,0,0,.07.13l3.49,7.4a.73.73,0,0,0,.67.43.71.71,0,0,0,.32-.07.75.75,0,0,0,.36-1L9.38,15a7.82,7.82,0,0,1,4.78.85,7.88,7.88,0,0,0,3.42.91,6.39,6.39,0,0,0,5-1.9l0,0,0,0a.56.56,0,0,0,.07-.16A.68.68,0,0,0,22.67,14.07Zm-5.09,1.21a6.45,6.45,0,0,1-2.8-.78,9.29,9.29,0,0,0-6.07-.9L4.58,4.86a7.86,7.86,0,0,1,4.79.85,7.8,7.8,0,0,0,3.42.91,7.09,7.09,0,0,0,4.15-1.18l4.15,8.78A5.49,5.49,0,0,1,17.58,15.28Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const FlagIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'flag'),
) as IconWithRender;

FlagIcon.displayName = 'FlagIcon';
FlagIcon.propTypes = Icon.propTypes;
FlagIcon.renderIcon = (props) => <FlagIcon {...props} />;
export default FlagIcon;
